"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "11",
    height: "8",
    viewBox: "0 0 11 8"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: props.fill,
    fillRule: "evenodd",
    points: "11.038 1.469 9.749 .18 5 5.5 1.918 2.58 .748 3.75 5 8"
  }));
};

exports["default"] = _default;